// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Replace with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyDL8GjmeF6RoyGXgqgtletpmxs78X4MhJk",
    authDomain: "playlorcana-b6632.firebaseapp.com",
    projectId: "playlorcana-b6632",
    storageBucket: "playlorcana-b6632.firebasestorage.app",
    messagingSenderId: "1088320921957",
    appId: "1:1088320921957:web:67630db7264dccae7b818c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore - domyślna baza danych
const db = getFirestore(app);

// Initialize limited-tierlist database - inna baza danych w tym samym projekcie
const limitedTierlistDb = getFirestore(app, "limited-tierlist");

// Initialize tracker database - inna baza danych w tym samym projekcie
const trackerDb = getFirestore(app, "tracker");

// Inicjalizacja Auth
const auth = getAuth(app);

// Inicjalizacja Storage
const storage = getStorage(app);

// Inicjalizacja Google Auth Provider
const googleProvider = new GoogleAuthProvider();

// Konfiguracja Google Maps
const googleMapsConfig = {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
};

export { app, db, limitedTierlistDb, trackerDb, auth, storage, googleProvider, googleMapsConfig };